import _ from 'lodash';
import { GetPassengerTypes } from '../constants';

const formatStateroomsInput = (
  staterooms,
  enabledTransportModes = undefined,
  selectedSearchMode,
) => {
  const passengerTypes = GetPassengerTypes(enabledTransportModes, selectedSearchMode);
  const adults = _.sumBy(staterooms, 'adults');
  const seniors = _.sumBy(staterooms, 'seniors');
  const children = _.sumBy(staterooms, 'children.length');
  const lapInfants = _.sumBy(staterooms, 'lapInfants');
  const seatInfants = _.sumBy(staterooms, 'seatInfants');

  const isMultipleTypesOfPassengersSelected =
    (adults > 0) + (seniors > 0) + (children > 0) + (lapInfants > 0) + (seatInfants > 0) > 1;
  const stateroomsString = staterooms.length > 1 ? `, ${staterooms.length} Rooms` : '';
  if (isMultipleTypesOfPassengersSelected) {
    return `${adults + seniors + children + lapInfants + seatInfants} Travelers${stateroomsString}`;
  }
  if (adults > 0) {
    const label =
      passengerTypes && passengerTypes.adults && passengerTypes.adults.text
        ? passengerTypes.adults.text
        : 'adult';
    return adults + (adults > 1 ? ` ${label}s` : ` ${label}`) + stateroomsString;
  }
  if (seniors > 0) {
    return seniors + (seniors > 1 ? ' Seniors' : ' Senior') + stateroomsString;
  }
  if (children > 0) {
    return children + (children > 1 ? ' Children' : ' Child') + stateroomsString;
  }
  if (lapInfants > 0 || seatInfants > 0) {
    return (
      lapInfants +
      seatInfants +
      (lapInfants + seatInfants > 1 ? ' Infants' : ' Infant') +
      stateroomsString
    );
  }
  return '';
};

export default formatStateroomsInput;
